module.exports = __webpack_public_path__ + "media/hallBgm.c801dae8.mp3";